import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAlertErrorComponent } from "./med-icon-alert-error.component";

@NgModule({
  declarations: [
    MedIconAlertErrorComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAlertErrorComponent,
  ],
})
export class MedIconAlertErrorModule { }
